<!-- Notifications toggle -->
<button
    mat-icon-button
    (click)="openPanel()"
    aria-label="Notifications"
    #notificationsOrigin>
    <ng-container *ngIf="unreadCount > 0">
        <span class="absolute top-0 right-0 left-0 flex items-center justify-center h-3 z-10">
            <span class="flex items-center justify-center flex-shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full bg-primary-600 text-primary-50 text-xs font-medium leading-extra-loose">
                {{unreadCount}}
            </span>
        </span>
    </ng-container>
    <mat-icon [svgIcon]="'heroicons_outline:bell'"></mat-icon>
</button>

<!-- Notifications panel -->
<ng-template #notificationsPanel>

    <div class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-100 sm:w-100 sm:rounded-2xl overflow-hidden shadow-lg ring-1 ring-opacity-50 ring-gray-200 right-10 message-tab-min-width">

        <!-- Header -->
        <div class="flex flex-shrink-0 items-center py-1 pr-4 pl-6 bg-card text-gray-700 border-b-2 border-gray-200">
            <div class="sm:hidden -ml-1 mr-3">
                <button
                    mat-icon-button
                    (click)="closePanel()">
                    <mat-icon
                        class="icon-size-5 text-current"
                        [svgIcon]="'heroicons_solid:x'"></mat-icon>
                </button>
            </div>
            <div class="text-2xl font-semibold leading-10">{{ getLocaleValue("notifications.header.notification_title")}}</div>
            <div class="ml-auto">
                <!-- <div class="relative inline-block mr-1 text-left">
                    <div>
                      <button
                      mat-icon-button
                      [matMenuTriggerFor]="moduleOptions" 
                      type="button" class="inline-flex justify-center w-full rounded-3xl bottom-1 border border-gray-300 shadow-sm px-2 bg-gray-200 text-md min-h-8 h-8 font-medium text-gray-700 focus:outline-none" id="menu-button" aria-expanded="true" aria-haspopup="true">
                        {{allModules[moduleFilter]}}
                        <svg class="-mr-1 ml-1 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                        </svg>
                      </button>
                    </div>
                  
                    <mat-menu #moduleOptions style="max-height: 208px;" class="zuper-scrollbar">
                        <button class="h-10 text-base primary-font"
                                *ngFor="let m of companyModules"
                                mat-menu-item
                                (click)="selectModuleFilter(m.module_key); getAllNotifications()">
                                {{_utilityService.convertModuleName(m)}}
                            </button>
                    </mat-menu>
                    
                </div> -->
                <button
                    mat-icon-button
                    [matTooltip]="('text.mark_all_as_read' | translate)"
                    [disabled]="unreadCount === 0"
                    (click)="markNotificationAsRead('mark_all_read')">
                    <mat-icon
                        class="icon-size-5 text-current"
                        [svgIcon]="'mat_solid:checklist'"></mat-icon>
                </button>
            </div>
        </div>

        <!-- Content -->
        <div class="relative flex items-center flex-col flex-auto max-h-80vh divide-y overflow-y-auto bg-card zuper-scrollbar" [ngClass]="{'min-h-120 justify-center' : allNotifications.length === 0 || showLoader}">
            <!-- Notifications -->
            <ng-container *ngFor="let notification of allNotifications; trackBy: trackByFn; let i = index">
                <div
                    id="notification_{{i}}"
                    class="flex group w-full hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5"
                    >

                    <!-- Notification with a link -->
                    <ng-container>
                        <!-- Normal links -->
                        <ng-container *ngIf="!notification.useRouter">
                            <a 
                            *ngIf="notification?.module !== 'BROADCAST'"
                            #notificationElement
                            (click)="onNotificationRead(notification)"
                            [routerLink] = 'getMenuLink(notification)'
                            [queryParams]="notification?.module === 'NON_JOB_EVENT' ? { type: 'NON_JOB_EVENT', action_uid: notification.action_uid } : null"
                             class="flex flex-auto py-5 pl-6 w-3/4 cursor-pointer"
                                
                                >
                                <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                            </a>

                            <span *ngIf="notification?.module === 'BROADCAST'" class="flex flex-auto py-5 pl-6 w-3/4 cursor-pointer" (click)="openBroadcastDrawerHandler()">
                                <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                            </span>
                        </ng-container>
                        
                    </ng-container>

                  

                    <!-- Actions -->
                    <div class="relative flex flex-col my-5 ml-2">
                        <button
                            class="ml-auto"
                            mat-icon-button
                            [matMenuTriggerFor]="notificationOptions">
                            <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_outline:dots-vertical'"></mat-icon>
                            <mat-menu #notificationOptions>
                                <button
                                    *ngIf="!notification.is_read"
                                    mat-menu-item
                                    class="text-base h-10"
                                    (click)="markNotificationAsRead('mark_one_read',notification)">
                                    <mat-icon  class="icon-size-5 text-current ti ti-checks"
                                     ></mat-icon>
                                    {{getLocaleValue("notifications.content.mark_as_read")}}
                                </button>
                            
                                <button mat-menu-item class="text-red-600 text-base h-10" (click)="deleteNotification(notification)">
                                    <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                                    {{getLocaleValue("notifications.content.delete_notification")}}
                                </button> 
                            </mat-menu>
                        </button>
                       
                    </div>

                </div>

                <!-- Notification content template -->
                <ng-template #notificationContent>
                    <!-- Icon -->
                    <ng-container >
                        
                        <div class="flex relative flex-shrink-0 items-center justify-center w-12 h-12 mr-4 rounded-full bg-primary-50 dark:bg-primary">
                            <div
                                style="width: 8px; height: 8px;"
                                class="absolute bottom-1 right-1 flex-0 -ml-0.5 rounded-full ring-2 ring-bg-card dark:ring-gray-900 bg-primary dark:bg-primary-500 text-on-primary"
                                *ngIf="!notification.is_read"
                            ></div>
                            <em *ngIf="!(notification.module === 'ROUTE')"
                                    [ngClass]="getIconClass(notification.module)" class="text-3xl font-medium"></em>
                                <img *ngIf="notification.module === 'ROUTE'"
                                    src="/assets/images/svgs/routes_notifications.svg" alt="" loading="lazy"
                                    class="font-medium w-8 h-8 rounded-full text3xl">
                        </div>
                    </ng-container>
                    <!-- Image -->
                    <ng-container *ngIf="notification.image">
                        <img
                            class="flex-shrink-0 w-8 h-8 mr-4 rounded-full overflow-hidden object-cover object-center"
                            [src]="notification.image"
                            [alt]="'Notification image'">
                    </ng-container>
                    <!-- Title, description & time -->
                    <div class="flex flex-col flex-auto w-3/4">
                        <ng-container *ngIf="notification.title">
                            <div
                                class="font-semibold line-clamp-1"
                                [innerHTML]="notification.title"></div>
                        </ng-container>
                        <ng-container *ngIf="notification.message">
                            <div
                                class="line-clamp-2 text-base"
                                [innerHTML]="notification.message"></div>
                        </ng-container>
                        <div class="mt-2 text-sm leading-none text-secondary">
                            {{notification.created_at | dateAgo}}
                        </div>
                    </div>
                </ng-template>
            </ng-container>

            <!-- No notifications -->
            <ng-container *ngIf="(!allNotifications || !allNotifications.length) && !showLoader">
                <div class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8">
                    <div class="flex flex-0 items-center justify-center w-14 h-14 mt-24 rounded-full bg-primary-100">
                        <mat-icon
                            class="text-primary-500-700"
                            [svgIcon]="'heroicons_outline:bell'"></mat-icon>
                    </div>
                    <div class="mt-5 text-2xl font-semibold tracking-tight">{{getLocaleValue("notifications.placeholder.no_notification_title")}}</div>
                    <div class="w-full max-w-60 mt-1 text-md text-center text-secondary">{{getLocaleValue("notifications.placeholder.no_notification_description")}}</div>
                </div>
            </ng-container>
            <ng-container>
                <mat-progress-spinner class="self-center justify-self-center mt-8 mb-8"
                *ngIf="showLoader && all_notifications_current_page === 1"
                [diameter]="45"
                [mode]="'indeterminate'">
                </mat-progress-spinner>
            </ng-container>
            <ng-container *ngIf="showLoader && all_notifications_current_page > 1">
                <div class="w-full mb-3 border-none mt-3">
                    <lazy-loader ></lazy-loader>
                </div>
            </ng-container>
            <div class="text-center border-none mb-3 mt-3" *ngIf="allNotifications.length >= all_notifications_current_page * 5 && (all_notifications_current_page < all_notifications_total_pages )"><a class="cursor-pointer" (click)="viewMoreNotification()">{{getLocaleValue("text.view_more")}}</a></div>
        </div>

    </div>
    

</ng-template>
